import store from '../store';
import {welcomeTourKey} from "./sessionHelper";
import { DateTime } from 'luxon'

interface SelectedEventObject {
    eventId: string;
    selectionTime: string;
}

const selectedKey = () => {
    return process.env.VUE_APP_SERVER + '_selected_event_' + store.state.session.backend;
}

const isWelcomeTourDone = (eventId: string): boolean => {
    let result = false;
    let welcomeTourFlags: any = localStorage.getItem(welcomeTourKey(store.state.session.backend)) || '{}';
    try {
        welcomeTourFlags = JSON.parse(welcomeTourFlags);
        result = !!(welcomeTourFlags && welcomeTourFlags[eventId]);
    }
    catch (e) {
        store.dispatch('reportError', e);
    }
    return result;
}

const setWelcomeTourDone = (eventId: string) => {
    const lsKey = welcomeTourKey(store.state.session.backend);
    let welcomeTourFlags: any = localStorage.getItem(lsKey) || '{}';
    try {
        welcomeTourFlags = JSON.parse(welcomeTourFlags) || {};
        welcomeTourFlags[eventId] = true;
        localStorage.setItem(lsKey, JSON.stringify(welcomeTourFlags));
    }
    catch (e) {
        store.dispatch('reportError', e);
    }
}

const removeWelcomeTourDone = () => {
    localStorage.removeItem(welcomeTourKey(store.state.session.backend));
}

const saveSelected = (selectedEventId: string) => {
    localStorage.setItem(selectedKey(), JSON.stringify({ eventId: selectedEventId, selectionTime: DateTime.local() }));
}

const getSelected = () => {

    try {
        const selectedEventObject: SelectedEventObject = JSON.parse(localStorage.getItem(selectedKey()) || "null");
        const eventId = selectedEventObject?.eventId;
        const selectionTime = DateTime.fromISO(selectedEventObject.selectionTime);

        if (eventId) {
            return selectionTime.plus({ days: 1 }) > DateTime.local() ? eventId : '';
        }

        return eventId;
    }
    catch {
        return ""
    }
}

export  {saveSelected, getSelected, isWelcomeTourDone, setWelcomeTourDone, removeWelcomeTourDone}
